module.exports = __webpack_public_path__ + "img/fundraisimg@2x.8450906a.png";